{
  "id": "carpathia",
  "name": "Carpathia",
  "viewBox": {
    "x": 0,
    "y": 37.23,
    "width": 1596.22,
    "height": 736.63
  },
  "backdropColor": {
    "light": "#e9dcb8",
    "dark": "#24251f",
    "topBar": true
  },
  "gameLayout": {},
  "selectionInnerGlow": true,
  "edgeConfig": {
    "internalBorderWidth": 4.6,
    "regionBorderWidth": 17.8,
    "bridgeStrokeWidth": 0
  },
  "regionToggleCorner": "bottom-left",
  "zoomToggleCorner": "right-of-regions",
  "regions": [
    {
      "id": "west-gate",
      "name": "West Gate",
      "bonus": 3,
      "shape": "M 9.3 416.9 L 9.3 416.9 L 7.7 422.9 L 5.6 432.0 L 3.8 441.1 L 14.2 448.3 L 23.4 439.5 L 33.5 441.9 L 40.0 450.0 L 44.1 455.7 L 44.9 462.6 L 50.7 467.0 L 51.6 474.3 L 50.2 480.9 L 48.1 487.3 L 45.0 493.4 L 43.3 499.9 L 35.0 504.4 L 34.8 513.9 L 37.7 521.5 L 39.4 529.6 L 48.8 524.9 L 54.2 533.9 L 60.1 535.2 L 63.2 536.0 L 65.0 545.0 L 66.4 551.6 L 66.4 558.3 L 66.8 565.0 L 69.2 571.3 L 68.3 578.5 L 72.6 584.3 L 71.4 591.1 L 74.3 597.5 L 82.7 597.2 L 87.1 604.3 L 92.0 609.9 L 93.5 617.3 L 100.1 619.6 L 107.0 620.4 L 113.8 621.7 L 120.0 625.0 L 129.9 628.5 L 140.4 628.4 L 147.3 636.2 L 155.7 642.4 L 157.1 630.8 L 166.1 623.3 L 176.7 620.7 L 187.4 618.5 L 181.9 627.4 L 179.5 637.6 L 186.3 645.5 L 194.8 651.5 L 192.8 660.8 L 189.1 669.6 L 196.1 676.2 L 200.0 685.0 L 207.4 677.9 L 215.9 683.7 L 223.6 681.1 L 230.1 676.3 L 237.7 679.5 L 245.8 679.0 L 252.7 673.1 L 261.4 675.7 L 264.5 676.2 L 325.9 548.4 L 342.1 537.5 L 413.1 408.1 L 353.4 320.2 L 365.7 180.6 L 335.4 85.9 L 332.4 87.7 L 327.3 95.2 L 319.6 100.0 L 311.5 104.0 L 303.6 108.2 L 297.7 99.9 L 287.5 100.1 L 276.6 108.2 L 263.4 105.1 L 254.5 116.4 L 260.1 129.5 L 248.5 128.9 L 237.0 129.8 L 233.3 118.5 L 225.0 110.0 L 218.1 115.1 L 209.6 113.9 L 202.2 116.9 L 194.4 118.4 L 185.0 119.1 L 176.2 115.7 L 166.9 120.0 L 164.8 130.0 L 164.1 138.8 L 157.6 144.8 L 153.5 152.6 L 144.9 155.0 L 136.8 157.5 L 132.0 164.5 L 126.4 170.2 L 120.0 175.0 L 128.5 182.8 L 126.3 194.1 L 117.2 201.8 L 120.6 213.3 L 124.33 220.54 L 119.8 222.5 L 108.2 227.0 L 92.8 224.1 L 88.6 236.4 L 77.2 242.7 L 66.5 249.3 L 60.0 260.0 L 60.4 266.9 L 59.5 273.8 L 55.1 279.3 L 53.6 286.3 L 48.2 290.4 L 44.4 296.2 L 41.4 302.3 L 36.7 307.3 L 33.2 315.3 L 26.2 320.4 L 25.8 329.8 L 17.8 334.9 L 22.6 342.2 L 30.4 346.1 L 35.4 352.9 L 40.0 360.0 L 34.2 363.8 L 30.7 369.8 L 29.5 376.5 L 27.2 382.9 L 27.8 390.3 L 25.3 397.3 L 18.4 399.9 L 13.0 405.0 L 10.2 413.9 L 9.3 416.9 L 9.3 416.9 L 9.3 416.9 Z",
      "territoryIds": [
        "stone-gate",
        "river-port",
        "merchant-row",
        "caravan-stop",
        "spice-bazaar"
      ],
      "color": "#388E3C",
      "bonusAnchor": {
        "x": 209.08,
        "y": 451.77
      }
    },
    {
      "id": "mountains",
      "name": "Cloud Mountains",
      "bonus": 4,
      "shape": "M 620.0 102.6 L 618.8 101.61 L 619.1 89.8 L 612.1 80.0 L 600.0 80.0 L 597.0 69.6 L 586.7 66.6 L 578.1 75.6 L 567.9 68.5 L 560.0 72.8 L 551.0 72.5 L 542.7 75.9 L 536.9 82.7 L 529.3 85.1 L 521.8 87.6 L 513.3 87.6 L 506.8 92.9 L 499.3 99.0 L 490.9 94.3 L 482.9 93.7 L 475.0 95.0 L 468.6 102.6 L 464.5 111.7 L 454.6 115.3 L 449.4 124.4 L 441.2 118.6 L 431.1 117.3 L 421.4 116.0 L 411.6 115.1 L 408.0 105.8 L 399.2 101.1 L 389.1 94.5 L 380.6 103.0 L 371.7 103.5 L 364.6 98.2 L 357.3 94.2 L 350.0 90.0 L 342.1 82.2 L 335.4 85.9 L 365.7 180.6 L 353.4 320.2 L 413.1 408.1 L 493.0 407.7 L 525.0 423.7 L 637.6 418.6 L 727.2 457.0 L 759.1 455.2 L 807.9 376.7 L 820.6 287.7 L 893.4 184.9 L 917.4 68.4 L 917.2 67.8 L 908.4 61.9 L 900.3 51.4 L 888.6 57.7 L 879.2 59.8 L 871.0 64.9 L 862.9 69.7 L 855.0 75.0 L 846.8 77.0 L 838.3 76.4 L 832.7 84.3 L 823.0 83.4 L 814.8 84.8 L 806.4 83.9 L 797.6 86.4 L 790.1 81.0 L 783.0 86.6 L 775.6 91.6 L 766.3 91.9 L 758.4 96.6 L 749.5 94.3 L 742.5 88.5 L 734.1 84.9 L 725.0 85.0 L 719.5 93.3 L 713.9 101.6 L 704.3 98.2 L 694.2 98.7 L 686.4 95.4 L 678.4 92.7 L 670.4 89.9 L 662.3 87.5 L 654.2 93.7 L 645.0 98.1 L 634.9 101.2 L 628.1 109.3 L 620.0 102.6 L 620.0 102.6 Z",
      "territoryIds": [
        "snowfang",
        "iron-pass",
        "wind-gap",
        "highscree",
        "cloudpeak"
      ],
      "color": "#F57C00",
      "bonusAnchor": {
        "x": 615.68,
        "y": 225.1
      }
    },
    {
      "id": "steppes",
      "name": "Steppes",
      "bonus": 4,
      "shape": "M 492.18 720.65 L 494.3 713.8 L 494.3 713.8 L 495.6 709.6 L 496.5 698.0 L 507.6 703.6 L 509.7 715.9 L 520.6 712.4 L 531.9 713.5 L 536.6 722.7 L 540.9 732.1 L 547.8 742.4 L 560.0 740.0 L 563.4 730.3 L 568.6 721.6 L 578.5 718.1 L 588.9 719.5 L 597.1 724.7 L 606.9 725.6 L 614.6 719.4 L 624.2 717.7 L 636.3 719.8 L 645.1 711.1 L 653.2 718.99 L 656.2 729.9 L 662.0 738.7 L 671.4 743.4 L 680.3 738.3 L 690.0 735.0 L 701.2 726.8 L 699.0 713.1 L 710.9 713.3 L 722.7 712.0 L 732.2 715.5 L 740.8 720.9 L 746.6 729.5 L 755.1 735.3 L 763.1 739.6 L 771.4 735.8 L 779.5 735.1 L 787.7 735.7 L 793.4 723.3 L 804.8 730.9 L 809.5 740.2 L 820.0 740.0 L 822.0 727.8 L 826.6 716.3 L 834.1 705.6 L 846.8 702.2 L 855.1 710.9 L 861.9 720.9 L 865.3 722.4 L 857.9 616.6 L 759.1 455.2 L 727.2 457.0 L 637.6 418.6 L 525.0 423.7 L 493.0 407.7 L 413.1 408.1 L 342.1 537.5 L 325.9 548.4 L 264.5 676.2 L 270.0 677.2 L 278.6 678.2 L 286.2 682.6 L 292.3 688.9 L 296.9 696.0 L 301.0 703.5 L 305.5 711.2 L 305.0 720.0 L 305.1 733.0 L 317.8 735.5 L 323.6 743.8 L 326.6 753.5 L 337.5 758.6 L 346.4 750.6 L 358.1 754.3 L 365.5 744.5 L 373.7 746.6 L 382.1 747.6 L 390.7 746.3 L 399.0 748.6 L 407.5 744.2 L 416.6 746.6 L 427.3 745.4 L 430.0 735.0 L 440.5 722.2 L 448.3 707.7 L 468.7 710.7 L 471.4 731.1 L 482.2 726.7 L 492.18 720.65 Z",
      "territoryIds": [
        "boneway",
        "stormjaw",
        "wolf-march",
        "salt-march",
        "yurt-camp"
      ],
      "color": "#EC407A",
      "bonusAnchor": {
        "x": 534.11,
        "y": 576.02
      }
    },
    {
      "id": "oasis",
      "name": "Oasis Heart",
      "bonus": 4,
      "shape": "M 1196.0 87.3 L 1188.5 84.1 L 1180.0 87.3 L 1171.9 83.2 L 1165.8 76.4 L 1157.2 79.6 L 1148.1 78.6 L 1139.6 75.5 L 1131.5 79.6 L 1123.2 78.6 L 1115.0 80.0 L 1107.5 73.4 L 1098.0 76.7 L 1089.2 75.9 L 1081.7 71.0 L 1071.4 70.6 L 1066.3 61.7 L 1057.6 68.5 L 1048.3 62.6 L 1038.2 58.0 L 1031.4 66.8 L 1023.6 70.6 L 1016.0 74.8 L 1007.9 79.7 L 1003.2 87.9 L 993.7 85.5 L 985.0 90.0 L 975.8 86.9 L 968.2 93.0 L 958.3 95.0 L 952.2 86.9 L 947.4 78.4 L 938.8 73.7 L 928.5 70.7 L 920.5 78.0 L 917.4 68.4 L 893.4 184.9 L 820.6 287.7 L 807.9 376.7 L 759.1 455.2 L 857.9 616.6 L 865.3 722.4 L 873.0 725.8 L 884.7 728.8 L 891.4 739.8 L 902.9 745.4 L 908.7 734.2 L 917.9 725.8 L 927.1 724.4 L 936.2 722.7 L 945.0 726.7 L 950.0 735.0 L 959.4 734.2 L 965.6 741.4 L 974.8 740.0 L 981.7 746.3 L 990.3 747.0 L 998.7 748.4 L 1007.5 750.3 L 1013.7 756.8 L 1023.2 759.7 L 1030.0 752.4 L 1038.6 752.4 L 1046.5 748.9 L 1055.1 749.1 L 1063.2 746.5 L 1071.6 746.2 L 1080.0 745.0 L 1081.2 732.8 L 1093.1 729.5 L 1103.2 725.2 L 1113.4 729.4 L 1126.6 727.2 L 1125.1 713.9 L 1134.0 709.9 L 1143.7 708.4 L 1154.5 709.0 L 1163.8 703.6 L 1172.0 710.8 L 1182.9 711.6 L 1189.7 718.6 L 1193.6 722.1 L 1185.3 615.2 L 1230.9 504.9 L 1203.0 364.7 L 1173.4 334.3 L 1196.0 87.3 Z",
      "territoryIds": [
        "well-of-suns",
        "sandgate",
        "ash-fields",
        "palm-grove",
        "saffron-court"
      ],
      "bonusAnchor": {
        "x": 1017.88,
        "y": 417.32
      },
      "color": "#00D4E8"
    },
    {
      "id": "east-gate",
      "name": "East Gate",
      "bonus": 3,
      "shape": "M 1398.4 122.3 L 1398.4 122.3 L 1395.2 121.3 L 1384.6 119.8 L 1375.0 115.0 L 1373.0 126.8 L 1364.7 135.5 L 1353.9 139.5 L 1342.4 140.3 L 1335.8 131.7 L 1325.4 128.5 L 1317.6 121.6 L 1308.1 117.2 L 1303.2 109.2 L 1294.0 107.3 L 1288.2 100.2 L 1279.4 97.9 L 1271.0 94.5 L 1262.7 90.9 L 1254.3 95.0 L 1245.0 95.0 L 1236.8 103.1 L 1225.8 99.9 L 1220.0 91.8 L 1213.3 84.5 L 1205.2 86.7 L 1196.8 87.6 L 1196.0 87.3 L 1173.4 334.3 L 1203.0 364.7 L 1230.9 504.9 L 1185.3 615.2 L 1193.6 722.1 L 1197.1 725.2 L 1204.7 731.6 L 1210.0 740.0 L 1218.1 738.5 L 1225.7 735.3 L 1233.6 732.9 L 1241.8 732.9 L 1247.4 726.3 L 1253.4 720.1 L 1261.6 716.4 L 1270.5 717.4 L 1279.1 715.8 L 1285.7 710.1 L 1294.1 710.5 L 1302.5 710.8 L 1312.6 706.8 L 1318.4 715.9 L 1326.6 712.9 L 1335.0 715.0 L 1341.8 723.3 L 1350.4 729.9 L 1361.4 728.7 L 1371.5 733.1 L 1379.5 725.9 L 1381.7 715.5 L 1387.3 706.9 L 1393.4 698.7 L 1400.5 692.8 L 1402.0 683.7 L 1410.5 681.3 L 1419.2 682.4 L 1428.4 682.3 L 1433.3 674.6 L 1435.5 666.8 L 1440.0 660.0 L 1438.7 645.0 L 1423.6 644.2 L 1416.1 635.0 L 1415.0 623.1 L 1420.1 611.8 L 1428.2 602.3 L 1440.9 605.1 L 1452.5 599.0 L 1458.4 593.1 L 1463.6 586.5 L 1472.2 587.7 L 1480.2 584.4 L 1488.2 581.5 L 1490.6 578.6 L 1490.6 578.6 L 1490.6 578.6 L 1493.6 574.9 L 1501.8 576.8 L 1510.0 575.0 L 1502.7 570.2 L 1498.8 562.4 L 1492.8 554.4 L 1497.6 545.6 L 1503.4 539.7 L 1506.0 531.9 L 1509.8 524.4 L 1516.9 520.1 L 1526.9 518.1 L 1535.7 523.0 L 1544.0 517.9 L 1553.7 516.9 L 1549.1 507.7 L 1545.5 498.1 L 1545.1 486.4 L 1555.0 480.0 L 1555.0 471.4 L 1548.2 466.0 L 1542.6 460.5 L 1538.9 453.6 L 1540.5 444.3 L 1532.4 439.6 L 1526.5 434.1 L 1524.2 426.4 L 1529.1 419.4 L 1533.1 411.9 L 1542.6 414.9 L 1549.5 407.5 L 1549.3 399.0 L 1553.7 391.7 L 1562.4 388.9 L 1565.0 380.0 L 1565.0 367.4 L 1553.3 362.7 L 1543.8 358.3 L 1535.3 352.0 L 1532.7 350.7 L 1523.4 346.0 L 1521.7 332.7 L 1508.9 324.9 L 1498.1 335.3 L 1486.8 324.2 L 1495.0 310.7 L 1497.5 298.4 L 1498.4 286.0 L 1516.5 284.0 L 1528.5 297.8 L 1529.2 279.4 L 1545.0 270.0 L 1547.5 262.5 L 1548.1 254.5 L 1544.8 247.3 L 1539.1 241.6 L 1537.2 233.7 L 1536.5 225.7 L 1529.9 221.0 L 1522.5 217.8 L 1517.9 211.2 L 1518.1 203.1 L 1510.6 200.7 L 1504.8 195.5 L 1494.2 196.2 L 1483.5 196.2 L 1479.7 185.3 L 1485.0 175.0 L 1476.2 168.4 L 1467.5 175.1 L 1459.2 178.3 L 1450.2 177.8 L 1441.9 174.9 L 1433.0 175.0 L 1423.1 178.1 L 1416.2 170.4 L 1420.7 160.1 L 1418.2 149.2 L 1415.7 138.8 L 1415.1 128.2 L 1405.2 124.6 L 1398.4 122.3 L 1398.4 122.3 L 1398.4 122.3 L 1398.4 122.3 Z",
      "territoryIds": [
        "amber-vault",
        "jade-tower",
        "ivory-port",
        "silk-court",
        "dragon-quay"
      ],
      "color": "#C0CA33",
      "bonusAnchor": {
        "x": 1387.89,
        "y": 380.95
      }
    }
  ],
  "territories": [
    {
      "id": "stone-gate",
      "name": "Stone Gate",
      "regionId": "west-gate",
      "adjacencies": [
        "merchant-row",
        "river-port",
        "spice-bazaar"
      ],
      "shape": "M 9.3 416.9 L 10.2 413.9 L 13 405 L 18.4 399.9 L 25.3 397.3 L 27.8 390.3 L 27.2 382.9 L 29.5 376.5 L 30.7 369.8 L 34.2 363.8 L 40 360 L 35.4 352.9 L 30.4 346.1 L 22.6 342.2 L 17.8 334.9 L 25.8 329.8 L 26.2 320.4 L 33.2 315.3 L 36.7 307.3 L 41.4 302.3 L 44.4 296.2 L 48.2 290.4 L 53.6 286.3 L 55.1 279.3 L 59.5 273.8 L 60.4 266.9 L 60 260 L 66.5 249.3 L 77.2 242.7 L 88.6 236.4 L 92.8 224.1 L 108.2 227 L 119.8 222.5 L 123.8 228 L 135 243 L 217.8 354.7 L 206.8 378.9 Z",
      "position": {
        "x": 110.3,
        "y": 326.6
      },
      "badgeAnchor": {
        "x": 111.39,
        "y": 328.81
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "river-port",
      "name": "River Port",
      "regionId": "west-gate",
      "adjacencies": [
        "snowfang",
        "spice-bazaar",
        "stone-gate",
        "wind-gap"
      ],
      "shape": "M 117.2 201.8 L 126.3 194.1 L 128.5 182.8 L 120 175 L 126.4 170.2 L 132 164.5 L 136.8 157.5 L 144.9 155 L 153.5 152.6 L 157.6 144.8 L 164.1 138.8 L 164.8 130 L 166.9 120 L 176.2 115.7 L 185 119.1 L 194.4 118.4 L 202.2 116.9 L 209.6 113.9 L 218.1 115.1 L 225 110 L 233.3 118.5 L 237 129.8 L 248.5 128.9 L 260.1 129.5 L 254.5 116.4 L 263.4 105.1 L 276.6 108.2 L 287.5 100.1 L 297.7 99.9 L 303.6 108.2 L 311.5 104 L 319.6 100 L 327.3 95.2 L 332.4 87.7 L 335.4 85.9 L 365.7 180.6 L 353.4 320.2 L 217.8 354.7 L 135 243 L 123.8 228 L 119.8 222.5 L 122.8 221.2 L 125.6 223.6 L 125.7 223.2 L 120.6 213.3 Z",
      "position": {
        "x": 256.9,
        "y": 233.1
      },
      "badgeAnchor": {
        "x": 253.1,
        "y": 232.9
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "merchant-row",
      "name": "Merchant Row",
      "regionId": "west-gate",
      "adjacencies": [
        "caravan-stop",
        "spice-bazaar",
        "stone-gate"
      ],
      "shape": "M 3.8 441.1 L 5.6 432 L 7.7 422.9 L 9.3 416.9 L 206.8 378.9 L 214.6 456.3 L 60.1 535.2 L 54.2 533.9 L 48.8 524.9 L 39.4 529.6 L 37.7 521.5 L 34.8 513.9 L 35 504.4 L 43.3 499.9 L 45 493.4 L 48.1 487.3 L 50.2 480.9 L 51.6 474.3 L 50.7 467 L 44.9 462.6 L 44.1 455.7 L 40 450 L 33.5 441.9 L 23.4 439.5 L 14.2 448.3 Z",
      "position": {
        "x": 102.5,
        "y": 453.5
      },
      "badgeAnchor": {
        "x": 111.39,
        "y": 449.72
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "caravan-stop",
      "name": "Caravan Stop",
      "regionId": "west-gate",
      "adjacencies": [
        "merchant-row",
        "spice-bazaar",
        "wolf-march"
      ],
      "shape": "M 60.1 535.2 L 214.6 456.3 L 325.9 548.4 L 264.5 676.2 L 261.4 675.7 L 252.7 673.1 L 245.8 679 L 237.7 679.5 L 230.1 676.3 L 223.6 681.1 L 215.9 683.7 L 207.4 677.9 L 200 685 L 196.1 676.2 L 189.1 669.6 L 192.8 660.8 L 194.8 651.5 L 186.3 645.5 L 179.5 637.6 L 181.9 627.4 L 187.4 618.5 L 176.7 620.7 L 166.1 623.3 L 157.1 630.8 L 155.7 642.4 L 147.3 636.2 L 140.4 628.4 L 129.9 628.5 L 120 625 L 113.8 621.7 L 107 620.4 L 100.1 619.6 L 93.5 617.3 L 92 609.9 L 87.1 604.3 L 82.7 597.2 L 74.3 597.5 L 71.4 591.1 L 72.6 584.3 L 68.3 578.5 L 69.2 571.3 L 66.8 565 L 66.4 558.3 L 66.4 551.6 L 65 545 L 63.2 536 Z",
      "position": {
        "x": 204.7,
        "y": 545.6
      },
      "badgeAnchor": {
        "x": 205.46,
        "y": 545.64
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "spice-bazaar",
      "name": "Spice Bazaar",
      "regionId": "west-gate",
      "adjacencies": [
        "boneway",
        "caravan-stop",
        "merchant-row",
        "river-port",
        "stone-gate",
        "wind-gap",
        "wolf-march"
      ],
      "shape": "M 206.8 378.9 L 217.8 354.7 L 353.4 320.2 L 413.1 408.1 L 342.1 537.5 L 325.9 548.4 L 214.6 456.3 Z",
      "position": {
        "x": 307.5,
        "y": 421
      },
      "badgeAnchor": {
        "x": 306.73,
        "y": 423.6
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "snowfang",
      "name": "Snowfang",
      "regionId": "mountains",
      "adjacencies": [
        "highscree",
        "iron-pass",
        "river-port",
        "wind-gap"
      ],
      "shape": "M 335.4 85.9 L 342.1 82.2 L 350 90 L 357.3 94.2 L 364.6 98.2 L 371.7 103.5 L 380.6 103 L 389.1 94.5 L 399.2 101.1 L 408 105.8 L 411.6 115.1 L 421.4 116 L 431.1 117.3 L 441.2 118.6 L 449.4 124.4 L 454.6 115.3 L 464.5 111.7 L 468.6 102.6 L 475 95 L 482.9 93.7 L 490.9 94.3 L 499.3 99 L 506.8 92.9 L 513.3 87.6 L 521.8 87.6 L 529.3 85.1 L 536.9 82.7 L 542.7 75.9 L 551 72.5 L 560 72.8 L 567.9 68.5 L 578.1 75.6 L 586.7 66.6 L 597 69.6 L 600 80 L 612.1 80 L 619.1 89.8 L 618.8 101.7 L 620 102.6 L 616.9 221.2 L 542.2 252.5 L 365.7 180.6 Z",
      "position": {
        "x": 539.7,
        "y": 166.4
      },
      "badgeAnchor": {
        "x": 535.51,
        "y": 168.26
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "iron-pass",
      "name": "Iron Pass",
      "regionId": "mountains",
      "adjacencies": [
        "cloudpeak",
        "sandgate",
        "snowfang",
        "well-of-suns"
      ],
      "shape": "M 616.9 221.2 L 620 102.6 L 628.1 109.3 L 634.9 101.2 L 645 98.1 L 654.2 93.7 L 662.3 87.5 L 670.4 89.9 L 678.4 92.7 L 686.4 95.4 L 694.2 98.7 L 704.3 98.2 L 713.9 101.6 L 719.5 93.3 L 725 85 L 734.1 84.9 L 742.5 88.5 L 749.5 94.3 L 758.4 96.6 L 766.3 91.9 L 775.6 91.6 L 783 86.6 L 790.1 81 L 797.6 86.4 L 806.4 83.9 L 814.8 84.8 L 823 83.4 L 832.7 84.3 L 838.3 76.4 L 846.8 77 L 855 75 L 862.9 69.7 L 871 64.9 L 879.2 59.8 L 888.6 57.7 L 900.3 51.4 L 908.4 61.9 L 917.2 67.8 L 917.4 68.4 L 893.4 184.9 L 820.6 287.7 L 617.4 221.8 Z",
      "position": {
        "x": 785.7,
        "y": 181.8
      },
      "badgeAnchor": {
        "x": 753.73,
        "y": 185.47
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "wind-gap",
      "name": "Wind Gap",
      "regionId": "mountains",
      "adjacencies": [
        "boneway",
        "highscree",
        "river-port",
        "snowfang",
        "spice-bazaar"
      ],
      "shape": "M 353.4 320.2 L 365.7 180.6 L 542.2 252.5 L 493 407.7 L 413.1 408.1 Z",
      "position": {
        "x": 440.1,
        "y": 300.4
      },
      "badgeAnchor": {
        "x": 438.95,
        "y": 297.9
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "highscree",
      "name": "Highscree",
      "regionId": "mountains",
      "adjacencies": [
        "boneway",
        "cloudpeak",
        "snowfang",
        "stormjaw",
        "wind-gap"
      ],
      "shape": "M 493 407.7 L 542.2 252.5 L 616.9 221.2 L 617.4 221.8 L 637.6 418.6 L 525 423.7 Z",
      "position": {
        "x": 576.43,
        "y": 332.22
      },
      "badgeAnchor": {
        "x": 576.43,
        "y": 332.22
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "cloudpeak",
      "name": "Cloudpeak",
      "regionId": "mountains",
      "adjacencies": [
        "ash-fields",
        "highscree",
        "iron-pass",
        "stormjaw",
        "well-of-suns",
        "yurt-camp"
      ],
      "shape": "M 617.4 221.8 L 820.6 287.7 L 807.9 376.7 L 759.1 455.2 L 727.2 457 L 637.6 418.6 Z",
      "position": {
        "x": 720.1,
        "y": 348.9
      },
      "badgeAnchor": {
        "x": 722.18,
        "y": 350.43
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "boneway",
      "name": "Boneway",
      "regionId": "steppes",
      "adjacencies": [
        "highscree",
        "salt-march",
        "spice-bazaar",
        "stormjaw",
        "wind-gap",
        "wolf-march"
      ],
      "shape": "M 342.1 537.5 L 413.1 408.1 L 493 407.7 L 525 423.7 L 533.5 573.3 L 495.7 602.7 Z",
      "position": {
        "x": 451.5,
        "y": 499.6
      },
      "badgeAnchor": {
        "x": 452.75,
        "y": 496.06
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "stormjaw",
      "name": "Stormjaw",
      "regionId": "steppes",
      "adjacencies": [
        "boneway",
        "cloudpeak",
        "highscree",
        "salt-march",
        "yurt-camp"
      ],
      "shape": "M 525 423.7 L 637.6 418.6 L 727.2 457 L 619 589.7 L 533.5 573.3 Z",
      "position": {
        "x": 602.6,
        "y": 493.6
      },
      "badgeAnchor": {
        "x": 603.98,
        "y": 496.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "wolf-march",
      "name": "Wolf March",
      "regionId": "steppes",
      "adjacencies": [
        "boneway",
        "caravan-stop",
        "salt-march",
        "spice-bazaar"
      ],
      "shape": "M 264.5 676.2 L 325.9 548.4 L 342.1 537.5 L 495.7 602.7 L 494.3 713.8 L 492.1 720.7 L 482.2 726.7 L 471.4 731.1 L 468.7 710.7 L 448.3 707.7 L 440.5 722.2 L 430 735 L 427.3 745.4 L 416.6 746.6 L 407.5 744.2 L 399 748.6 L 390.7 746.3 L 382.1 747.6 L 373.7 746.6 L 365.5 744.5 L 358.1 754.3 L 346.4 750.6 L 337.5 758.6 L 326.6 753.5 L 323.6 743.8 L 317.8 735.5 L 305.1 733 L 305 720 L 305.5 711.2 L 301 703.5 L 296.9 696 L 292.3 688.9 L 286.2 682.6 L 278.6 678.2 L 270 677.2 Z",
      "position": {
        "x": 402.11,
        "y": 639.45
      },
      "badgeAnchor": {
        "x": 402.11,
        "y": 639.45
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "salt-march",
      "name": "Salt March",
      "regionId": "steppes",
      "adjacencies": [
        "boneway",
        "stormjaw",
        "wolf-march",
        "yurt-camp"
      ],
      "shape": "M 494.3 713.8 L 495.7 602.7 L 533.5 573.3 L 619 589.7 L 652.9 718.7 L 645.1 711.1 L 636.3 719.8 L 624.2 717.7 L 614.6 719.4 L 606.9 725.6 L 597.1 724.7 L 588.9 719.5 L 578.5 718.1 L 568.6 721.6 L 563.4 730.3 L 560 740 L 547.8 742.4 L 540.9 732.1 L 536.6 722.7 L 531.9 713.5 L 520.6 712.4 L 509.7 715.9 L 507.6 703.6 L 496.5 698 L 495.6 709.6 Z",
      "position": {
        "x": 563.9,
        "y": 651
      },
      "badgeAnchor": {
        "x": 566.17,
        "y": 649.92
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "yurt-camp",
      "name": "Yurt Camp",
      "regionId": "steppes",
      "adjacencies": [
        "ash-fields",
        "cloudpeak",
        "palm-grove",
        "salt-march",
        "stormjaw"
      ],
      "shape": "M 619 589.7 L 727.2 457 L 759.1 455.2 L 857.9 616.6 L 865.3 722.4 L 861.9 720.9 L 855.1 710.9 L 846.8 702.2 L 834.1 705.6 L 826.6 716.3 L 822 727.8 L 820 740 L 809.5 740.2 L 804.8 730.9 L 793.4 723.3 L 787.7 735.7 L 779.5 735.1 L 771.4 735.8 L 763.1 739.6 L 755.1 735.3 L 746.6 729.5 L 740.8 720.9 L 732.2 715.5 L 722.7 712 L 710.9 713.3 L 699 713.1 L 701.2 726.8 L 690 735 L 680.3 738.3 L 671.4 743.4 L 662 738.7 L 656.2 729.9 L 653.2 719 L 652.9 718.7 Z",
      "position": {
        "x": 734.2,
        "y": 610.3
      },
      "badgeAnchor": {
        "x": 738.3,
        "y": 612.81
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "well-of-suns",
      "name": "Well of Suns",
      "regionId": "oasis",
      "adjacencies": [
        "ash-fields",
        "cloudpeak",
        "iron-pass",
        "saffron-court",
        "sandgate"
      ],
      "shape": "M 807.9 376.7 L 820.6 287.7 L 893.4 184.9 L 1062.7 364.6 L 1018.4 427 Z",
      "position": {
        "x": 902.5,
        "y": 314.5
      },
      "badgeAnchor": {
        "x": 907.43,
        "y": 317.3
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "sandgate",
      "name": "Sandgate",
      "regionId": "oasis",
      "adjacencies": [
        "amber-vault",
        "iron-pass",
        "saffron-court",
        "well-of-suns"
      ],
      "shape": "M 893.4 184.9 L 917.4 68.4 L 920.5 78 L 928.5 70.7 L 938.8 73.7 L 947.4 78.4 L 952.2 86.9 L 958.3 95 L 968.2 93 L 975.8 86.9 L 985 90 L 993.7 85.5 L 1003.2 87.9 L 1007.9 79.7 L 1016 74.8 L 1023.6 70.6 L 1031.4 66.8 L 1038.2 58 L 1048.3 62.6 L 1057.6 68.5 L 1066.3 61.7 L 1071.4 70.6 L 1081.7 71 L 1089.2 75.9 L 1098 76.7 L 1107.5 73.4 L 1115 80 L 1123.2 78.6 L 1131.5 79.6 L 1139.6 75.5 L 1148.1 78.6 L 1157.2 79.6 L 1165.8 76.4 L 1171.9 83.2 L 1180 87.3 L 1188.5 84.1 L 1196 87.3 L 1173.4 334.3 L 1062.7 364.6 Z",
      "position": {
        "x": 1065.8,
        "y": 193.3
      },
      "badgeAnchor": {
        "x": 1068.34,
        "y": 196.93
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ash-fields",
      "name": "Ash Fields",
      "regionId": "oasis",
      "adjacencies": [
        "cloudpeak",
        "palm-grove",
        "saffron-court",
        "well-of-suns",
        "yurt-camp"
      ],
      "shape": "M 759.1 455.2 L 807.9 376.7 L 1018.4 427 L 1019 488.1 L 857.9 616.6 Z",
      "position": {
        "x": 881,
        "y": 485.1
      },
      "badgeAnchor": {
        "x": 884.99,
        "y": 485.4
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "palm-grove",
      "name": "Palm Grove",
      "regionId": "oasis",
      "adjacencies": [
        "ash-fields",
        "saffron-court",
        "silk-court",
        "yurt-camp"
      ],
      "shape": "M 857.9 616.6 L 1019 488.1 L 1185.3 615.2 L 1193.6 722.1 L 1189.7 718.6 L 1182.9 711.6 L 1172 710.8 L 1163.8 703.6 L 1154.5 709 L 1143.7 708.4 L 1134 709.9 L 1125.1 713.9 L 1126.6 727.2 L 1113.4 729.4 L 1103.2 725.2 L 1093.1 729.5 L 1081.2 732.8 L 1080 745 L 1071.6 746.2 L 1063.2 746.5 L 1055.1 749.1 L 1046.5 748.9 L 1038.6 752.4 L 1030 752.4 L 1023.2 759.7 L 1013.7 756.8 L 1007.5 750.3 L 998.7 748.4 L 990.3 747 L 981.7 746.3 L 974.8 740 L 965.6 741.4 L 959.4 734.2 L 950 735 L 945 726.7 L 936.2 722.7 L 927.1 724.4 L 917.9 725.8 L 908.7 734.2 L 902.9 745.4 L 891.4 739.8 L 884.7 728.8 L 873 725.8 L 865.3 722.4 Z",
      "position": {
        "x": 1020.5,
        "y": 634.3
      },
      "badgeAnchor": {
        "x": 1020.5,
        "y": 636.63
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "saffron-court",
      "name": "Saffron Court",
      "regionId": "oasis",
      "adjacencies": [
        "amber-vault",
        "ash-fields",
        "ivory-port",
        "palm-grove",
        "sandgate",
        "silk-court",
        "well-of-suns"
      ],
      "shape": "M 1018.4 427 L 1062.7 364.6 L 1173.4 334.3 L 1203 364.7 L 1230.9 504.9 L 1185.3 615.2 L 1019 488.1 Z",
      "position": {
        "x": 1122.2,
        "y": 447.1
      },
      "badgeAnchor": {
        "x": 1121.33,
        "y": 444.03
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "amber-vault",
      "name": "Amber Vault",
      "regionId": "east-gate",
      "adjacencies": [
        "ivory-port",
        "jade-tower",
        "saffron-court",
        "sandgate"
      ],
      "shape": "M 1173.4 334.3 L 1196 87.3 L 1196.8 87.6 L 1205.2 86.7 L 1213.3 84.5 L 1220 91.8 L 1225.8 99.9 L 1236.8 103.1 L 1245 95 L 1254.3 95 L 1262.7 90.9 L 1271 94.5 L 1279.4 97.9 L 1288.2 100.2 L 1294 107.3 L 1303.2 109.2 L 1308.1 117.2 L 1317.6 121.6 L 1325.4 128.5 L 1335.8 131.7 L 1342.4 140.3 L 1353.9 139.5 L 1364.7 135.5 L 1373 126.8 L 1375 115 L 1384.6 119.8 L 1395.2 121.3 L 1398.4 122.3 L 1356.8 343.3 L 1203 364.7 Z",
      "position": {
        "x": 1281.8,
        "y": 216.4
      },
      "badgeAnchor": {
        "x": 1282.38,
        "y": 220.22
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jade-tower",
      "name": "Jade Tower",
      "regionId": "east-gate",
      "adjacencies": [
        "amber-vault",
        "dragon-quay",
        "ivory-port"
      ],
      "shape": "M 1356.8 343.3 L 1398.4 122.3 L 1405.2 124.6 L 1415.1 128.2 L 1415.7 138.8 L 1418.2 149.2 L 1420.7 160.1 L 1416.2 170.4 L 1423.1 178.1 L 1433 175 L 1441.9 174.9 L 1450.2 177.8 L 1459.2 178.3 L 1467.5 175.1 L 1476.2 168.4 L 1485 175 L 1479.7 185.3 L 1483.5 196.2 L 1494.2 196.2 L 1504.8 195.5 L 1510.6 200.7 L 1518.1 203.1 L 1517.9 211.2 L 1522.5 217.8 L 1529.9 221 L 1536.5 225.7 L 1537.2 233.7 L 1539.1 241.6 L 1544.8 247.3 L 1548.1 254.5 L 1547.5 262.5 L 1545 270 L 1529.2 279.4 L 1528.5 297.8 L 1516.5 284 L 1498.4 286 L 1497.5 298.4 L 1495 310.7 L 1486.8 324.2 L 1498.1 335.3 L 1508.9 324.9 L 1521.7 332.7 L 1523.4 346 L 1532.7 350.7 L 1394.8 376.3 Z",
      "position": {
        "x": 1442.6,
        "y": 249.4
      },
      "badgeAnchor": {
        "x": 1437.5,
        "y": 261.21
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ivory-port",
      "name": "Ivory Port",
      "regionId": "east-gate",
      "adjacencies": [
        "amber-vault",
        "dragon-quay",
        "jade-tower",
        "saffron-court",
        "silk-court"
      ],
      "shape": "M 1203 364.7 L 1356.8 343.3 L 1394.8 376.3 L 1384.1 483.7 L 1230.9 504.9 Z",
      "position": {
        "x": 1311.1,
        "y": 421.7
      },
      "badgeAnchor": {
        "x": 1313.88,
        "y": 421.58
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "silk-court",
      "name": "Silk Court",
      "regionId": "east-gate",
      "adjacencies": [
        "dragon-quay",
        "ivory-port",
        "palm-grove",
        "saffron-court"
      ],
      "shape": "M 1185.3 615.2 L 1230.9 504.9 L 1384.1 483.7 L 1490.6 578.6 L 1488.2 581.5 L 1480.2 584.4 L 1472.2 587.7 L 1463.6 586.5 L 1458.4 593.1 L 1452.5 599 L 1440.9 605.1 L 1428.2 602.3 L 1420.1 611.8 L 1415 623.1 L 1416.1 635 L 1423.6 644.2 L 1438.7 645 L 1440 660 L 1435.5 666.8 L 1433.3 674.6 L 1428.4 682.3 L 1419.2 682.4 L 1410.5 681.3 L 1402 683.7 L 1400.5 692.8 L 1393.4 698.7 L 1387.3 706.9 L 1381.7 715.5 L 1379.5 725.9 L 1371.5 733.1 L 1361.4 728.7 L 1350.4 729.9 L 1341.8 723.3 L 1335 715 L 1326.6 712.9 L 1318.4 715.9 L 1312.6 706.8 L 1302.5 710.8 L 1294.1 710.5 L 1285.7 710.1 L 1279.1 715.8 L 1270.5 717.4 L 1261.6 716.4 L 1253.4 720.1 L 1247.4 726.3 L 1241.8 732.9 L 1233.6 732.9 L 1225.7 735.3 L 1218.1 738.5 L 1210 740 L 1204.7 731.6 L 1197.1 725.2 L 1193.6 722.1 Z",
      "position": {
        "x": 1311.3,
        "y": 600.9
      },
      "badgeAnchor": {
        "x": 1304.56,
        "y": 599.84
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "dragon-quay",
      "name": "Dragon Quay",
      "regionId": "east-gate",
      "adjacencies": [
        "ivory-port",
        "jade-tower",
        "silk-court"
      ],
      "shape": "M 1384.1 483.7 L 1394.8 376.3 L 1532.7 350.7 L 1535.3 352 L 1543.8 358.3 L 1553.3 362.7 L 1565 367.4 L 1565 380 L 1562.4 388.9 L 1553.7 391.7 L 1549.3 399 L 1549.5 407.5 L 1542.6 414.9 L 1533.1 411.9 L 1529.1 419.4 L 1524.2 426.4 L 1526.5 434.1 L 1532.4 439.6 L 1540.5 444.3 L 1538.9 453.6 L 1542.6 460.5 L 1548.2 466 L 1555 471.4 L 1555 480 L 1545.1 486.4 L 1545.5 498.1 L 1549.1 507.7 L 1553.7 516.9 L 1544 517.9 L 1535.7 523 L 1526.9 518.1 L 1516.9 520.1 L 1509.8 524.4 L 1506 531.9 L 1503.4 539.7 L 1497.6 545.6 L 1492.8 554.4 L 1498.8 562.4 L 1502.7 570.2 L 1510 575 L 1501.8 576.8 L 1493.6 574.9 L 1490.6 578.6 Z",
      "position": {
        "x": 1458.5,
        "y": 454.8
      },
      "badgeAnchor": {
        "x": 1460.42,
        "y": 453.97
      },
      "ownerId": "",
      "armies": 0
    }
  ],
  "geometryVersion": "v1-2662f199-320ca1c7",
  "seaRoutes": []
}
